import { render, staticRenderFns } from "./Ssign.vue?vue&type=template&id=3bb5549b&scoped=true"
import script from "./Ssign.vue?vue&type=script&lang=js"
export * from "./Ssign.vue?vue&type=script&lang=js"
import style0 from "./Ssign.vue?vue&type=style&index=0&id=3bb5549b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5549b",
  null
  
)

export default component.exports